import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';

import {ComponentsModule} from '../shared/components/components.module';

import {OptionsRoutingModule} from './options-routing.module';

import {OptionsComponent} from './options.component';
import {PipesModule} from "../shared/pipes/pipes.module";
import { DonationMenuComponent } from './donation-menu/donation-menu.component';
import { DonationKakaopayComponent } from './donation-kakaopay/donation-kakaopay.component';


@NgModule({
  declarations: [
    OptionsComponent,
    DonationMenuComponent,
    DonationKakaopayComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    ComponentsModule,
    OptionsRoutingModule,
    PipesModule,
  ]
})
export class OptionsModule {
}
